module.exports = __webpack_public_path__ + "img/tool.05c7062e.svg";